module.exports = __webpack_public_path__ + "static/media/presentique.0d0366e1.jpg";